import { CRTMSG, DELMSG } from 'src/Helper/toastmsg';
import {
  PURCHASE_WOI_STATE, PURCHASE_WI_LOCAL,

  PURCHASE_WI_CREATE, PURCHASE_WI_LIST, PURCHASE_WI_SINGLE,
  PURCHASE_WI_UPDATE, PURCHASE_WI_DELETE,

  PURCHASE_WOI_CREATE, PURCHASE_WOI_LIST, PURCHASE_WOI_SINGLE,
  PURCHASE_WOI_UPDATE, PURCHASE_WOI_DELETE,

  CLEAR_PURCHASE_TEMP_STATES, CLEAR_PURCHASE_STATES, PURCHASE_ACCOUNT,
} from '../../../../Helper/actionsTypes';

const purchaseReducer = (state = {
  wi_state: {
    pcs: false,
    size: false,
  }
}, action) => {
  const { code, results, message } = action.payload || ''
  switch (action.type) {
    case PURCHASE_WOI_STATE: {
      return { ...state, woi_state: action.payload };
    }
    case PURCHASE_WI_LOCAL: {
      return { ...state, wi_state: action.payload };
    }
    case PURCHASE_WI_LIST: {
      return code === 200
        ? { ...state, wi_list: results }
        : { ...state, wi_list: [] };
    }
    case PURCHASE_WOI_LIST: {
      return code === 200
        ? { ...state, woi_list: results }
        : { ...state, woi_list: [] };
    }
    case PURCHASE_WI_SINGLE: {
      return code === 200
        ? { ...state, wi_single: results }
        : { ...state, wi_single: {} };
    }
    case PURCHASE_WOI_SINGLE: {
      return code === 200
        ? { ...state, woi_single: results }
        : { ...state, woi_single: {} };
    }
    case PURCHASE_ACCOUNT :{
      return code === 200
      ? { ...state, purchaseAccount: results }
        : { ...state, purchaseAccount: [] };
    }
    case PURCHASE_WI_DELETE: {
      return code === 200
        ? { ...state, wi_itemDeleted: true, message }
        : code === 400 ? { ...state, wi_itemDeleted: false, badReq: true, message }
          : code === 500 ? { ...state, wi_itemDeleted: false, message: DELMSG }
            : { ...state, wi_itemDeleted: false, message };
    }
    case PURCHASE_WOI_DELETE: {
      return code === 200
        ? { ...state, woi_itemDeleted: true, message }
        : code === 400 ? { ...state, woi_itemDeleted: false, badReq: true, message }
          : code === 500 ? { ...state, woi_itemDeleted: false, message: DELMSG }
            : { ...state, woi_itemDeleted: false, message };
    }
    case PURCHASE_WI_CREATE: {
      return code === 200
        ? { ...state, wi_itemSaved: true, message }
        : code === 400 ? { ...state, wi_itemSaved: false, badReq: true, message }
          : code === 500 ? { ...state, wi_itemSaved: false, message: CRTMSG }
            : { ...state, wi_itemSaved: false, message };
    }
    case PURCHASE_WOI_CREATE: {
      return code === 200
        ? { ...state, woi_itemSaved: true, message }
        : code === 400 ? { ...state, woi_itemSaved: false, badReq: true, message }
          : code === 500 ? { ...state, woi_itemSaved: false, message: CRTMSG }
            : { ...state, woi_itemSaved: false, message };
    }
    case PURCHASE_WI_UPDATE: {
      return code === 200
        ? { ...state, wi_itemUpdated: true, message }
        : code === 400 ? { ...state, wi_itemUpdated: false, badReq: true, message }
          : code === 500 ? { ...state, wi_itemUpdated: false, message: CRTMSG }
            : { ...state, wi_itemUpdated: false, message };
    }
    case PURCHASE_WOI_UPDATE: {
      return code === 200
        ? { ...state, woi_itemUpdated: true, message }
        : code === 400 ? { ...state, woi_itemUpdated: false, badReq: true, message }
          : code === 500 ? { ...state, woi_itemUpdated: false, message: CRTMSG }
            : { ...state, woi_itemUpdated: false, message };
    }
    case CLEAR_PURCHASE_TEMP_STATES: return {
      ...state,
      wi_itemDeleted: null, woi_itemDeleted: null,
      wi_itemSaved: null, woi_itemSaved: null,
      wi_itemUpdated: null, woi_itemUpdated: null,
      wi_delete: {}, woi_delete: {},
      wi_create: {}, woi_create: {},
      wi_update: {}, woi_update: {},
      message: null, badReq: null,woi_list:[]
    };
    case CLEAR_PURCHASE_STATES: return {
      woi_state: {
        tax: null,
        taxType: null,
        dropName: 'Amt',
        isTaxType: false,
        isTaxation: false,
        dropdownOpen: false,
        roundOff: 0,
      },
      wi_state: {
        pcs: false,
        size: false,
        dropName: 'Amt',
        roundOff: 0,
        isTaxType: false,
        isTaxation: false,
        tax: null,
        taxType: null,
      }
    };
    default: return state;
  }
};

export default purchaseReducer;